import React from 'react'
import theme from 'styles/theme'
import styled from 'styled-components'
import { media } from 'styles/media'

import Header from 'components/landing/Header'
import LazyImage from 'components/display/LazyImage'
import HelpSection from 'components/display/HelpSection'
import Container from 'components/layout/Container'
import Booking from './Booking/index'
import Gifting from './Gifting/index'
import Hosting from './Hosting/index'
import Storytelling from './Storytelling/index'
import { headerImage } from './content'

const SectionContainer = styled(Container)`
  margin: 48px auto;

  &:last-child {
    margin-bottom: 160px;
  }

  ${media.md`
    margin: 80px auto;
  `}
`

const HowItWorks = () => {
  return (
    <>
      <Header
        h2Text="How Riparide works"
        h3Text="Riparide's Stories inspire city-dwellers to book short nature escapes and experience fulfilling moments through our unique accommodation and adventures."
        backgroundColour={theme?.['-ds-neutral-200'].value}
      >
        <LazyImage
          data-src={headerImage.large.url}
          data-srcset={`
            ${headerImage.medium.url} ${headerImage.medium.width}w,
            ${headerImage.large.url} ${headerImage.large.width}w,
            ${headerImage.hero.url} ${headerImage.hero.width}w,
          `}
          preload
        />
      </Header>

      <SectionContainer>
        <Booking />
      </SectionContainer>

      <Gifting />

      <SectionContainer>
        <Hosting />
      </SectionContainer>

      <Storytelling />

      <SectionContainer>
        <HelpSection alignment="center" link="https://help.riparide.com/" />
      </SectionContainer>
    </>
  )
}

export default HowItWorks
